import { RouteObject } from "react-router-dom";
import { BillingWorkflow } from "./components/BillingWorkflow";
export interface BulkBillGenerationRoute extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: BulkBillGenerationRoute[];
}
export const bulkBillGenerationRoutes: BulkBillGenerationRoute[] = [
  {
    path: "bx/create-bill-generation",
    element: <BillingWorkflow />,
  },
  {
    path: "bx/create-bill-generation/:id/:action",
    element: <BillingWorkflow />,
  },
  {
    path: "bx/create-bill-generation/:id/:billRunId/:action",
    element: <BillingWorkflow />,
  },
];
